import React from 'react';
import { Route } from 'react-router-dom';
import slug from 'constants/slug';
import FacilityDeviceList from './FacilityDeviceList';
import FacilityDeviceCreate from './FacilityDeviceCreate';
import FacilityDeviceEdit from './FacilityDeviceEdit';
import FacilityDeviceView from './FacilityDeviceView';

export default props => [
  <Route
    exact
    key={slug.FACILITY_DEVICE.LIST}
    path={slug.FACILITY_DEVICE.LIST}
    render={matchProps => <FacilityDeviceList isShowExpandSearch {...matchProps} {...props} />}
  />,
  <Route
    key={slug.FACILITY_DEVICE.CREATE}
    path={slug.FACILITY_DEVICE.CREATE}
    render={matchProps => <FacilityDeviceCreate {...matchProps} {...props} />}
  />,
  <Route
    key={slug.FACILITY_DEVICE.VIEW}
    path={slug.FACILITY_DEVICE.VIEW}
    render={matchProps => <FacilityDeviceView {...matchProps} {...props} />}
  />,
  <Route
    key={slug.FACILITY_DEVICE.EDIT}
    path={slug.FACILITY_DEVICE.EDIT}
    render={matchProps => <FacilityDeviceEdit {...matchProps} {...props} />}
  />
];



// WEBPACK FOOTER //
// ./src/containers/FacilityDeviceContainer/index.js